import axios from "axios";
import { SSO_CONFIG } from "../constants/sso";

class BackendService {
  constructor(collection) {
    this.collection = collection;
    this.baseUrl = process.env.REACT_APP_KAT_BACKEND_BASE_URL;
    this.instance = axios.create();
  }

  setAccessToken(accessToken) {
    localStorage.setItem("ACCESS_TOKEN", accessToken);
  }

  getAccessToken() {
    return localStorage.getItem("ACCESS_TOKEN");
  }

  collectionUrl(collectionName) {
    return this.baseUrl + collectionName + "/";
  }

  async accessToken(credentials) {
    const apiUrl = this.baseUrl + "auth/token";
    const { data } = await this.instance.post(apiUrl, credentials);

    if (data.access_token != null) {
      return data.access_token;
    } else {
      return null;
    }
  }

  async signInWithSSO(code) {
    const apiUrl = this.baseUrl + "auth/sso/kutubee";
    const { data } = await this.instance.post(apiUrl, {
      code,
      redirectUri: SSO_CONFIG.REDIRECT_URI,
    });

    if (data.access_token != null) {
      this.setAccessToken(data.access_token);
      return data.access_token;
    } else {
      return null;
    }
  }

  async signIn(email, password) {
    const apiUrl = this.baseUrl + "auth/login";
    const { data } = await this.instance.post(apiUrl, { email, password });

    if (data.access_token != null) {
      this.setAccessToken(data.access_token);
      return data.access_token;
    } else {
      return null;
    }
  }

  async resetPassword(email) {
    const apiUrl = this.baseUrl + "auth/reset-password";
    await this.instance.post(apiUrl, { email });
    return true;
  }

  async requestAccessToken(credentials) {
    const accessToken = await this.accessToken(credentials);
    if (accessToken) {
      this.setAccessToken(accessToken);
    } else {
      this.setAccessToken(null);
    }
  }

  async getAll() {
    const apiUrl = this.collectionUrl(this.collection);
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.instance.get(apiUrl, options);
    const updatedData = data.map((doc) => ({
      ...doc,
      id: doc._id,
    }));
    return updatedData;
  }

  async getOne(id) {
    const apiUrl = this.collectionUrl(this.collection) + id;
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.instance.get(apiUrl, options);
    const updatedData = {
      ...data,
      id: data._id,
    };
    return updatedData;
  }

  async getMany(ids) {
    const apiUrl = this.collectionUrl(this.collection);
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const postData = { ids: ids };
    const { data } = await this.instance.post(apiUrl, postData, options);
    const updatedData = data.map((doc) => ({
      ...doc,
      id: doc._id,
    }));
    return updatedData;
  }

  async getManyByFieldId(field, id) {
    const apiUrl = this.collectionUrl(this.collection);
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const postData = { [field]: id };
    const { data } = await this.instance.post(apiUrl, postData, options);
    const updatedData = data.map((doc) => ({
      ...doc,
      id: doc._id,
    }));
    return updatedData;
  }

  async getManyByFilter(filterObj) {
    const apiUrl = this.collectionUrl(this.collection);
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.instance.post(apiUrl, filterObj, options);
    const updatedData = data.map((doc) => ({
      ...doc,
      id: doc._id,
    }));
    return updatedData;
  }

  async addOne(postData) {
    const apiUrl = this.collectionUrl(this.collection);
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.instance.put(apiUrl, postData, options);
    return data;
  }

  async deleteOne(id) {
    const apiUrl = this.collectionUrl(this.collection) + id;
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    await this.instance.delete(apiUrl, options);
  }

  async updateOne(id, postData) {
    const apiUrl = this.collectionUrl(this.collection) + id;
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.instance.put(apiUrl, postData, options);
    return data;
  }

  async getSubResource(id, subPath) {
    const apiUrl = this.collectionUrl(this.collection) + id + `/${subPath}`;
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.instance.get(apiUrl, options);
    return { ...data, id: data._id };
  }

  async getUserProfile() {
    const apiUrl = this.baseUrl + "users/profile";
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.instance.get(apiUrl, options);
    return { ...data, id: data._id };
  }

  async updateProfile(updatedData) {
    const apiUrl = this.baseUrl + "users/profile";
    const accessToken = this.getAccessToken();
    const options = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };
    const { data } = await this.instance.put(apiUrl, updatedData, options);
    return data;
  }
}
export default BackendService;
